import Template from "../templates/CreateUser/CreateUserTemplate";

const CreateUser = () => <Template />;

export default CreateUser;
